import { epicDependencies } from '../../../../store';
import { CmpsSdpNumberPipe } from '../sdp-number.pipe';

export function sdpNumber(value: number | null): string | null {
    // TODO FIXME. this can be done better
    return epicDependencies.injector
        .get<CmpsSdpNumberPipe>(CmpsSdpNumberPipe)
        ?.transform(value);
}
